import React, { Component } from 'react';
import { array, bool, func, number, object, string } from 'prop-types';
import LoadingList from '../LoadingStates/LoadingList';
import ReloadableSection from '../ErrorStates/ReloadableSection';
import Survey from './Survey/Survey';
import SurveyUtilizationTabs from './SurveyUtlilizationTabs/SurveyUtilizationTabs';
import classnames from 'classnames';

import './SurveyUtilization.scss';

const MAX_MESSAGE = 'You have reached the max retries, please refresh the whole page.';

class SurveyUtilization extends Component {
  static propTypes = {
    bottomRetries: number,
    bottomSurveys: array,
    bottomSurveysError: string,
    bottomSurveysLoading: bool,
    browseSurveysClick: func,
    changeSurveysClick: func,
    reFetchBottomSurveys: func,
    reFetchTopSurveys: func,
    surveyClick: func,
    topRetries: number,
    topSurveys: array,
    topSurveysError: string,
    topSurveysLoading: bool,
    canChangeSurveyLibrary: bool
  };

  constructor(props) {
    super(props);

    this.state = { showTopSurveys: true };

    this.renderSurveys = this.renderSurveys.bind(this);
    this.surveyTabChange = this.surveyTabChange.bind(this);
  }

  handleSurveyClick(surveyId) {
    const { surveyClick } = this.props;

    surveyClick(surveyId);
  }

  renderSurveys() {
    const { bottomSurveys, topSurveys } = this.props;
    const { showTopSurveys } = this.state;
    let surveys = null;
    if (showTopSurveys) surveys = topSurveys;
    else surveys = bottomSurveys;

    return surveys.map(survey => {
      return (
        <Survey
          className={showTopSurveys ? 'top' : 'bottom'}
          id={survey.id}
          jobCount={survey.jobCount}
          key={survey.id}
          name={survey.name}
          percentUtilziation={survey.utilization}
          surveyClick={this.handleSurveyClick.bind(this, survey.id)}
        />
      );
    });
  }

  surveyTabChange() {
    const { showTopSurveys } = this.state;

    this.setState({
      showTopSurveys: !showTopSurveys
    });
  }

  render() {
    const {
      bottomRetries,
      bottomSurveysError,
      bottomSurveysLoading,
      browseSurveysClick,
      changeSurveysClick,
      reFetchBottomSurveys,
      reFetchTopSurveys,
      topRetries,
      topSurveysError,
      topSurveysLoading,
      canChangeSurveyLibrary
    } = this.props;
    const { showTopSurveys } = this.state;
    const hasError = showTopSurveys ? topSurveysError : bottomSurveysError;
    const errorMessage =
      retries < 3 ? `An error occured loading the ${showTopSurveys ? 'Top' : 'Bottom'} 5 surveys` : MAX_MESSAGE;
    const isLoading = showTopSurveys ? topSurveysLoading : bottomSurveysLoading;
    const reloadAction = showTopSurveys ? reFetchTopSurveys : reFetchBottomSurveys;
    const retries = showTopSurveys ? topRetries : bottomRetries;
    const headerClassNames = classnames('survey__utilization--header', {
      'header--single-link': !canChangeSurveyLibrary
    });

    return (
      <div className="survey__utilization">
        <div className={headerClassNames}>
          <div className="survey__utilization--title">Survey Utilization</div>
          <div className="survey__utilization--links">
            <div className="browse-survey--link" onClick={browseSurveysClick}>
              Browse Surveys
            </div>
            {canChangeSurveyLibrary && (
              <React.Fragment>
                <span className="survey-link__spacer">|</span>
                <div className="change-survey--link" onClick={changeSurveysClick}>
                  Change Surveys
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
        <SurveyUtilizationTabs surveyTabChange={this.surveyTabChange} />
        <div className="survey__utilization--surveys">
          {isLoading ? (
            <LoadingList />
          ) : hasError.length ? (
            <ReloadableSection errorMessage={errorMessage} reloadAction={reloadAction} showReload={retries <= 3} />
          ) : (
            this.renderSurveys()
          )}
        </div>
      </div>
    );
  }
}

export default SurveyUtilization;
